
export class ColumnDefinitionsModel {
  field: string;
  secondaryField?: string;
  caption: string;
  type: string;
  enableFilter?: boolean;
  enableSorting?: boolean;
  sortDirection?: string;
  cssClass?: string;
  customTemplate?: string;
  customContent?: string;
  priority?: number;
}
